import { createSlice } from '@reduxjs/toolkit';

import { announcementApi } from '../../../services/announcements';

export type Announcement = {
  id: string;
  tenantId: string;
  title: string;
  text: string;
  type: string;
  audienceType: string;
  isActive: boolean;
  priorityColourCode: string;
  sortOrder: number;
  timeStamp: string;
};

export type AnnouncementState = {
  isAnnouncementOpen: boolean;
  announcementData: Announcement[];
};

const initialState: AnnouncementState = {
  isAnnouncementOpen: false,
  announcementData: []
};

const announcementSlice = createSlice({
  name: 'announcements',
  initialState,
  reducers: {
    setIsAnnouncementOpen: (state, action) => {
      state.isAnnouncementOpen = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addMatcher(
      announcementApi.endpoints.getAnnouncements.matchFulfilled,
      (state, action) => {
        if (action.payload?.data.length != 0) {
          state.isAnnouncementOpen = true;
        }
        state.announcementData = action.payload?.data || [];
      }
    );
  }
});

export const { setIsAnnouncementOpen } = announcementSlice.actions;
export default announcementSlice.reducer;
